module.exports = "/assets/site/images/MVM_teke.jpg?2940a03e438209d2fc9aa9528622f71e";